import { AppError } from "config/errors";
import { ICase } from "config/types";
import { getCasesQuery } from "gql/queries/case";
import { SET_CASES } from "store/constants";

import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       ACTIONS     ------------------ */

export const setCases = createAction(SET_CASES, (cases: ICase[]) => {
  return {
    type: SET_CASES,
    payload: {
      cases,
    },
  };
});

/* ------------       THUNKS      ------------------ */

export const getCases = createAsyncThunk("cases/getCases", async (_, { rejectWithValue }) => {
  try {
    const response = await getCasesQuery();

    return response.data.cases;
  } catch (err) {
    return rejectWithValue(AppError.from(err).toPlainObject());
  }
});
